export const shareTabConstant = {
  overview: "0",
  financialFigures: "1",
  news: "2",
};
